"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Application_instances, _Application_render;
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const App_1 = __importDefault(require("./App"));
const application_1 = require("./config/application");
require("./index.css");
class Application extends HTMLElement {
    constructor() {
        super();
        _Application_instances.add(this);
        // Define the `this.shadowRoot` readonly property by calling `attachShadow`.
        this.attachShadow({ mode: 'open' });
    }
    connectedCallback() {
        __classPrivateFieldGet(this, _Application_instances, "m", _Application_render).call(this);
    }
    attributeChangedCallback(attribute, _previous, next) {
        __classPrivateFieldGet(this, _Application_instances, "m", _Application_render).call(this, { [attribute]: next });
    }
}
_Application_instances = new WeakSet(), _Application_render = function _Application_render(properties) {
    (0, react_dom_1.render)((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(App_1.default, Object.assign({}, properties)) }), this.shadowRoot);
};
customElements.define(application_1.customElementTagName, Application);
